// extracted by mini-css-extract-plugin
export default {"value-item":"AboutValueItem_value-item__PAj1A","value-icon":"AboutValueItem_value-icon__1Czy8","value-text":"AboutValueItem_value-text__FJNjf"};